import { useWatch } from "react-hook-form";
import { useTranslations } from "use-intl";
import { FormSelect } from "@/components/form/rhf/FormSelect";
import {
  useAgenticModelOptions,
  useReferenceOptionsWithCurrent,
} from "../use-agentic-reference-options";

interface AgenticModelSelectProps {
  name: string;
  label: string;
  required?: boolean;
}

export function AgenticModelSelect({ name, label, required }: AgenticModelSelectProps) {
  const t = useTranslations("workflows");
  const currentValue = useWatch({ name }) as string | undefined;
  const { options, isLoading } = useAgenticModelOptions();
  const safeOptions = useReferenceOptionsWithCurrent(options, currentValue);

  return (
    <FormSelect
      name={name}
      label={label}
      options={safeOptions}
      placeholder={
        isLoading
          ? t("drawer.placeholder.loading_models")
          : t("drawer.placeholder.select_model")
      }
      disabled={isLoading || safeOptions.length === 0}
      required={required}
    />
  );
}
